import React, { createContext, useState, useContext, useEffect } from 'react';

export type InputFilter = {[key: string]: string}
type SearchParamsType = {
    [key: string]: string | null;
  };
const InitialMessageType : InputFilter = { };

// Create a context with a default value
const FilterContext = createContext({
    filterData: InitialMessageType,
    initialFiltersSet: false,
    updateFilter: (name: string, value: string) => {},
    deleteFilter: (name: string) => {},
    findFilterFromParams: (paramNames: string[]) => { return {} as SearchParamsType },
    setInitialFilters: (paramNames: string[], params : URLSearchParams) => {},
    getUrlParameterString: (paramNames: string[]) => { return "" as string }
});


  
// This stores the filter data and provides functions to update it
// and to find filters from URL parameters
export const FilterProvider = ({ children }: { children: React.ReactNode }) => {
    const [filterData, setFilterData] = useState<InputFilter>(InitialMessageType);
    const [initialFiltersSet, setInitialFiltersSet] = useState<boolean>(false);

    const setInitialFilters = (paramNames: string[], params : URLSearchParams) => {
        paramNames.forEach((name) => {
            const value = params.get(name);
            if (value !== null) {
                setFilterData(prev => ({ ...prev, [name]: value }));
            }
        });
        setInitialFiltersSet(true);
    }

    const updateFilter = (name : string, value : string) => {
        setFilterData(prev => ({ ...prev, [name]: value }));
    };

    const deleteFilter = (name : string) => {
        setFilterData(prev => {
            const { [name]: _, ...rest } = prev;
            return rest;
        });
    }
    const findFilterFromParams = (paramNames: string[]) => {
        paramNames.push("sort_by");
        const searchParams: SearchParamsType = {};
        paramNames.forEach((name) => {
            searchParams[name] = filterData.hasOwnProperty(name) ? filterData[name] : null;
          });
        return searchParams
    }

    const getUrlParameterString = (paramNames: string[]) => {
        const searchParams: SearchParamsType = findFilterFromParams(paramNames);
        const urlParams = new URLSearchParams();
        Object.entries(searchParams).forEach(([key, value]) => {
            if (value !== null) {
                urlParams.append(key, value);
            }
        });
        return urlParams.toString();
    }

    return (
      <FilterContext.Provider value={{ filterData, initialFiltersSet, updateFilter, deleteFilter, findFilterFromParams, setInitialFilters, getUrlParameterString }}>
        {children}
      </FilterContext.Provider>
    );
  };
export const useFilter = () => useContext(FilterContext);